/* eslint-disable import/extensions */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getIn, useFormikContext } from 'formik'

import { UseSignUpForm } from '../../model/line.model'
import { setFields } from '../../store/line.reducer'
import { selectLinePhoneNumber } from '../../store/line.selectors'

import { selectIsOffline } from '~/agent/store/agent.selectors'
import { SignUpType, PortabilityType, SignUp } from '~/basket/model/lines/signup.model'
import { RootState } from '~/core/store/root.reducer'
import useValidateForm from '~/sale/hooks/useValidateForm'

export default function useSignUpForm(id: string): UseSignUpForm {
  const { values, isValid, errors } = useFormikContext<SignUp>()

  const isOffline = useSelector(selectIsOffline)
  const phoneNumber = useSelector((state: RootState) => selectLinePhoneNumber(state, id))
  const dispatch = useDispatch()

  const isPortability = getIn(values, 'signUpType') === SignUpType.PORTABILITY
  const isPrepaid = getIn(values, 'portabilityType') === PortabilityType.PREPAID && isPortability
  const isNewProduct = getIn(values, 'signUpType') === SignUpType.NEW_LINE

  useValidateForm({
    lineId: id,
    form: 'signUp',
    isValidForm: isValid && !!phoneNumber,
    refreshValue: phoneNumber,
  })

  useEffect(() => {
    dispatch(setFields({ lineId: id, ...values }))
  }, [values])

  return {
    isPrepaid,
    isPortability,
    isNewProduct,
    isOffline,
  }
}
